/* ⚛ REACT */
import { useState, useEffect } from "react";

/* 📦 LIBS */
import { useTranslation } from "react-i18next";

/* 🎨 STYLES */
import { Container, SelectInput, InvalidText, ContainerInput, ImageIcons, SelectOption } from "./styles";
/* 🔧 UTILS */
import { isValidaProp } from "../../util/validate";

const InputSelect = (props) => {

    const { t } = useTranslation();

    const [isValid, setIsValid] = useState(true);
    const [color, setColor] = useState('#C7C7C7');
    const [value, setValue] = useState(props.value);
    let options = isValidaProp(props.options) ? props.options : [];
   
    useEffect(() => {
        if(props.value){
            setIsValid(props.validationFunction(props.value));
            props.validationFunction(props.value) ? setColor('#006560') : setColor('#FF3939');
        }
        setValue(props.value);
    },[props])

    function ApplyHover (){
        color !== '#006560' && color !== '#FF3939' ? setColor('#A3A3A3') : setColor(color);
    }

    function ApplyBlur(){
        color !== '#006560' && color !== '#FF3939' ? setColor('#C7C7C7') : setColor(color);
    }

    return(
        <Container>
            <ContainerInput $isvalid={isValid} $borderColor={color} onMouseOver={() => ApplyHover()} onMouseOut={() => ApplyBlur()}>
                {props.icon ? <ImageIcons src={props.icon} color={color}/> : <></>}
                <SelectInput 
                    tabIndex={0} 
                    name={props.name}
                    id={props.id}
                    placeholder={props.placeholder}
                    ref={props.innerRef}
                    value={value}
                    disabled={props.disabled === true}
                    onChange={(e)  => {
                        setIsValid(props.validationFunction(e.target.value));
                        props.onchange(e.target.value);
                        props.validationFunction(e.target.value) ? setColor('#006560') : setColor('#FF3939');
                        setValue(e.target.value);
                    }}
                    onFocus={() => color !== '#FF3939' ? setColor('#006560') : setColor(color)}
                    onBlur={(e) => {
                        setIsValid(props.validationFunction(e.target.value))
                        props.validationFunction(e.target.value) ? setColor('#006560') : setColor('#FF3939');
                    }}
                    $isvalid={isValid}>
                        <SelectOption value={''} defaultValue="selected">{t("select.option")}</SelectOption>
                        {Array.isArray(options) && options.map((option, index) => (
                            <SelectOption key={option.code_ibge || option.code_uf || option.id} value={option.code_ibge || option.code_uf || option.id}>{option.name || option.title || option.nome}</SelectOption>
                        ))} 
                </SelectInput>
            </ContainerInput>
            <InvalidText $visibility={isValid}>{props.invalidMessage}</InvalidText>
        </Container>
    )
}

export default InputSelect;